module.exports = __webpack_public_path__ + "img/gw.df2a6e12.svg";